import React, { useEffect } from "react";
import { useInView } from "react-intersection-observer";
import { Helper } from "../tools/Helper";
import { api_Routes } from "../api_Routes";

const ViewOnScroll = ({ children,currentPage,perPage,selectedCategory,sortingField,sortingOrder,isAd }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  useEffect(() => {
    if (inView) {
      Helper.Post({
        url: api_Routes.UserAds.OnSee,
        data:{
          currentPage,
          perPage,
          selectedCategory,
          sortingField,
          sortingOrder,
          isAd
        },
        hasToken: true,
      });
    }
  }, [inView,currentPage,perPage,selectedCategory,sortingField,sortingOrder,isAd]);

  return <div ref={ref}>{inView && children}</div>;
};

export default ViewOnScroll;
